import type { Component } from "solid-js";
import SaveYearlyIcon from "~/Icons/Icon_Save_Yearly.svg?component-solid";

// Может пригодиться в будущем на след акцию
// import SaveYearlyBlackFrid
import { Switch, useCustomContext } from "~/solidJs/shared";
import { PricingPageParams } from "~/solidJs/shared/models/pageParams";
import { PricingPageContext } from "../methods";

export const SwitchPaymentLength: Component = () => {
	const store = useCustomContext(PricingPageContext);

	return (
		<div class="flex w-max flex-col gap-2">
			<SaveYearlyIcon class="custom-tw-hidden md:block" />
			{/* <SaveYearlyBlackFridayIcon class="custom-tw-hidden md:block" /> */}
			<Switch
				size="md"
				colorStyle="purple"
				class="flex gap-2"
				onCheckedChange={(d) => {
					store.setSubscriptionLength(
						d.checked
							? PricingPageParams.SubscriptionLength.Year
							: PricingPageParams.SubscriptionLength.Month
					);
				}}
				inputProps={{
					"data-test": "premium-switch-period-input"
				}}
				checked={store.getIsLengthYear()}
				data-test="premium-switch-period"
				data-test-period={`premium-switch-period-${store.getIsLengthYear() ? "long" : "short"}`}
			>
				<div class="typography-text-14-medium text-text-secondary-v2">Yearly</div>
			</Switch>
		</div>
	);
};
